"use client";
import { useState, useEffect } from "react";
import { ModalCustom } from "../../../components/custom/modal-custom";
import {
  CLOTHING_CATEGORY_STATUS,
  CLOTHING_CATEGORY_STATUS_NAME,
} from "../services/clothing-category-service";
import { ClothingCategoryRow } from "./clothing-categories-table";

export interface ClothingCategoryFormValues {
  name: string;
  code?: string;
  sort_order: number;
  status?: number;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: ClothingCategoryFormValues) => Promise<boolean>;
  loading?: boolean;
  editData?: ClothingCategoryRow | null;
}

const ClothingCategoryModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  loading,
  editData,
}) => {
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [sortOrder, setSortOrder] = useState("0");
  const [status, setStatus] = useState<CLOTHING_CATEGORY_STATUS>(CLOTHING_CATEGORY_STATUS.ACTIVE);

  useEffect(() => {
    if (editData) {
      setName(editData.name || "");
      setCode(editData.code || "");
      setSortOrder(String(editData.sort_order ?? 0));
      setStatus(editData.status as CLOTHING_CATEGORY_STATUS);
    } else {
      setName("");
      setCode("");
      setSortOrder("0");
      setStatus(CLOTHING_CATEGORY_STATUS.ACTIVE);
    }
  }, [editData, isOpen]);

  const handleSubmit = async () => {
    if (!name.trim()) return;
    const values: ClothingCategoryFormValues = {
      name: name.trim(),
      code: code.trim() || undefined,
      sort_order: Number(sortOrder) || 0,
    };
    if (editData) {
      values.status = status;
    }
    const ok = await onSubmit(values);
    if (ok) onClose();
  };

  const bodyModal = (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">
          Tên loại đồ <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="VD: Đồ trắng, Đồ lao động, Mỏng nhẹ..."
          className="w-full border rounded px-3 py-2 text-sm"
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">
            Mã (tùy chọn)
          </label>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="VD: DO_TRANG"
            className="w-full border rounded px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Thứ tự hiển thị</label>
          <input
            type="number"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            placeholder="0"
            className="w-full border rounded px-3 py-2 text-sm"
          />
        </div>
      </div>
      {editData && (
        <div>
          <label className="block text-sm font-medium mb-1">Trạng thái</label>
          <select
            value={status}
            onChange={(e) => setStatus(Number(e.target.value) as CLOTHING_CATEGORY_STATUS)}
            className="w-full border rounded px-3 py-2 text-sm"
          >
            {Object.entries(CLOTHING_CATEGORY_STATUS_NAME).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );

  const footerModal = (
    <div className="flex gap-2">
      <button
        type="button"
        onClick={onClose}
        className="px-4 py-2 text-sm border rounded hover:bg-gray-50"
      >
        Hủy
      </button>
      <button
        type="button"
        onClick={handleSubmit}
        disabled={loading || !name.trim()}
        className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? "Đang xử lý..." : editData ? "Cập nhật" : "Tạo mới"}
      </button>
    </div>
  );

  return (
    <ModalCustom
      titleModal={editData ? "Cập nhật loại đồ" : "Thêm loại đồ mới"}
      isOpen={isOpen}
      onClose={() => onClose()}
      bodyModal={bodyModal}
      footerModal={footerModal}
      modalSize="lg"
    />
  );
};

export default ClothingCategoryModal;
